import { toast } from 'react-toastify';

export function showErrorMessage(message: string): void {
  toast.error(message);
}

export function showSuccessMessage(message: string): void {
  toast.success(message);
}
